import { useEffect } from "react";
import { loadCSS } from "fg-loadcss";

function ComplexGrid(props) {
  const fontFunc = () => {
    const node = loadCSS(
      "https://use.fontawesome.com/releases/v5.12.0/css/all.css",
      document.querySelector("#font-awesome-css")
    );

    return () => {
      node.parentNode.removeChild(node);
    };
  };
  useEffect(() => {
    fontFunc();
  }, [props.data.icon, props.data.color]);

  return (
    <>
      <div className={`card_content_icon d-flex align-items-center`}>
        <div className={`card_content_icon_i me-3`}>
          <i
            className={`fa fa-${props.data.icon}`}
            style={{
              fontSize: `${props.data.fontSize}00%`,
              color: props.data.color,
            }}
          />
        </div>
        <div className=" card_content_icon_details">{props.children}</div>
      </div>
    </>
  );
}

const iconwithLink = {
  Renderer: (props) => <ComplexGrid {...props} />,
  id: "iconWithLink",
  version: "iconWithLink",
  title: "icon with Link",
};

export default iconwithLink;
